"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _react = _interopRequireDefault(require("react"));
var _reactLazyLoad = _interopRequireDefault(require("react-lazy-load"));
var _intl = require("@kyruus/intl");
var _Videocam = _interopRequireDefault(require("@kyruus/react-ikons/Videocam"));
var _providerComponents = require("@kyruus/provider-components");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _styles = require("./styles");
var _images = require("../../lib/images");
var _globals = require("../../lib/constants/globals");
var _messages = _interopRequireDefault(require("../../lib/constants/messages"));
var _providerProfileLink = _interopRequireDefault(require("../ProviderProfileLink/provider-profile-link"));
const ProviderImage = _ref => {
  let {
    provider,
    summaryCallback,
    summaryUrl,
    track,
    lazyLoadImg,
    isProfileDisabled = false,
    config
  } = _ref;
  const hasVideoV8 = (0, _isArray.default)(provider.provider_videos) && provider.provider_videos.length > 0;
  const hasVideoV9 = Boolean(provider.video_url);
  const showProviderVideoBanner = (0, _get2.default)(config, 'provider_tile.show_provider_video_banner', false);
  const shouldDisplayVideoBanner = !isProfileDisabled && (hasVideoV8 || hasVideoV9) && showProviderVideoBanner; // check config to show/hide provider watch video banner

  const providerImage = /*#__PURE__*/_react.default.createElement(_styles.ProviderImageContainer, null, lazyLoadImg ? /*#__PURE__*/_react.default.createElement(_reactLazyLoad.default, {
    debounce: false,
    offsetVertical: 800
  }, /*#__PURE__*/_react.default.createElement(_styles.ProviderImg, {
    alt: (0, _providerComponents.getProviderDisplayName)(provider),
    id: `image${provider.id}`,
    src: (0, _images.getProviderImageUrl)(provider)
  })) : /*#__PURE__*/_react.default.createElement(_styles.ProviderImg, {
    alt: (0, _providerComponents.getProviderDisplayName)(provider),
    id: `image${provider.id}`,
    src: (0, _images.getProviderImageUrl)(provider)
  }), shouldDisplayVideoBanner && /*#__PURE__*/_react.default.createElement(_styles.ProviderVideoBanner, {
    "data-testid": "ProviderVideoBanner"
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.hasvideo), /*#__PURE__*/_react.default.createElement(_Videocam.default, {
    size: "12px",
    "aria-hidden": "true"
  })));
  return isProfileDisabled ? providerImage : /*#__PURE__*/_react.default.createElement(_providerProfileLink.default, {
    id: "view-details-image",
    provider: provider,
    pageSection: _globals.LOGGING.PAGE_SECTION.PROVIDER_IMAGE,
    navCallback: summaryCallback,
    navUrl: summaryUrl,
    track: track,
    "aria-labelledby": `view-details-${provider.id}`
  }, providerImage);
};
var _default = exports.default = ProviderImage;
ProviderImage.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProviderImage",
  "props": {
    "isProfileDisabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    }
  }
};